var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.count)+" "+_vm._s(_vm.correctNumerus))]},{"count":_vm.count,"numerus":_vm.correctNumerus,"singular":_vm.isSingular,"plural":_vm.isPlural})],2)}
var staticRenderFns = []

export { render, staticRenderFns }